import { ILocationResponse } from '@kcftech/prometheustypescriptapiclient';
import { useMutation } from '@tanstack/react-query';
import { DropdownInlineEditor } from 'components/inline_edit/DropdownInlineEditor';
import { useNotificationContext } from 'contexts/NotificationContext';
import { usePermissions } from 'contexts/PermissionsContext';
import { updateLocation } from 'utils/location';
import { OptionChild } from 'utils/node';

export const lineFrequencyOptions: OptionChild<number>[] = [
    {
        Text: '50 Hz',
        Value: 50,
    },
    {
        Text: '60 Hz',
        Value: 60,
    },
];

export type LocationLineFrequencyCellProps = Readonly<{
    rowData: ILocationResponse;
    onChange: () => void;
    className?: string;
}>;

export function LocationLineFrequencyInlineEditor({
    rowData,
    onChange,
}: LocationLineFrequencyCellProps) {
    const { canEditLocationDetails } = usePermissions();
    const selectedOption = lineFrequencyOptions.find(
        (option) => option.Value === rowData.Settings.LineFrequency
    );

    const { showToast } = useNotificationContext();
    const { mutate: updateLineFrequency, isPending } = useMutation({
        mutationFn: (lineFrequencyUpdate: OptionChild<number> | undefined) =>
            updateLocation(rowData, {
                LineFrequency: lineFrequencyUpdate?.Value,
            }),

        onSuccess: () => {
            onChange();
            showToast({
                type: 'success',
                content: 'Successfully updated location line frequency',
            });
        },

        onError: () =>
            showToast({
                type: 'error',
                content: 'Failed to save location line frequency',
            }),
    });

    return (
        <DropdownInlineEditor
            options={lineFrequencyOptions}
            dropdownConfig={{
                renderLabel: ({ value }) => value?.Text,
                dataKey: (item) => item.Value,
                renderItem: ({ item }) => item.Text,
                popup: { width: '16rem' },
            }}
            value={selectedOption}
            renderValue={(value) => value?.Text}
            onConfirm={updateLineFrequency}
            isDisabled={isPending || !canEditLocationDetails}
        />
    );
}
